import styled from "styled-components";
import { media } from "../../../../../../components/common/media";

export default styled.div`
  background: #fff;
  height: inherit;
  position: relative;

  .license-option {
    margin-left: 15px;
  }

  .shopify__product--wrapper {
    min-height: 100px;
    position: relative;
    .MuiCircularProgress-root {
      position: absolute;
      top: calc(50% - 20px);
      left: calc(50% - 20px);
      color: #f04f38;
    }
  }
  .descriptionNote {
    padding-top: 20px;
  }

  p {
    color: rgba(0, 0, 0, 0.87);
    font-size: 14px;
    margin-bottom: 8px;
  }

  td {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }

  .detailSep {
    border-top: 3px solid #f2f0f0;
    margin: 20px -15px 30px;
  }

  .light p,
  p.light {
    color: #bababa !important;
  }

  .light {
    margin-top: -5px;
  }

  button.cartButton {
    background: ${(props) => props.theme.colors.primary.main};
    color: #fff !important;
    padding: 15px 30px;
    width: 80%;
    transition: all 0.6s ease 0s;
    overflow: hidden;
    position: relative;
    font-size: 14px;
    font-weight: 600;
    margin: 0;
    ${media.phone`
      width: 95%;
    `};
    ${media.tablet`
      width: 90%;
    `};
    &.disabled {
      cursor: not-allowed;
      background: #e4e4e4;
      pointer-events: none;
      color: rgba(0, 0, 0, 0.38) !important;
      &:hover {
        background: #a4a9ad;
      }
    }
    &.is-added {
      .button--text {
        color: transparent;
        transform: translateX(0);
        transition: transform 0s;
        background: none;
      }
      svg {
        transform: translateX(-50%) translateY(-50%);
        transition: transform 0s;
        opacity: 1;

        path {
          stroke-dashoffset: 0;
          transition: all 0.4s ease 0s;
        }
      }
    }
    svg {
      position: absolute;
      left: 50%;
      top: 50%;
      width: 100%;
      transform: translateX(50%) translateY(-50%);
      transition: transform 0.3s;
      opacity: 0;
    }
    .button--text {
      transition: transform 0.3s;
      transform: translateZ(0);
      backface-visibility: hidden;
    }
    &:hover {
      background: ${(props) => props.theme.colors.primary.dark};
      color: #ffffff;
    }
  }
  button {
    color: #fff;
    border: none;
    width: 170px;
    height: 44px;
    transition: all 0.6s ease 0s;
    cursor: pointer;
    &:hover {
      background: #e0331a;
    }

    @media only screen and (max-device-width: 667px) and (min-device-width: 320px) and (orientation: portrait) {
      margin-right: 0;
    }

    ${media.desktop`
      width: 170px;
    `};
    &.MuiIconButton-root {
      width: auto;
      height: auto;
      background: transparent;
      margin: auto;
    }
  }

  .addToCart {
    clear: both;
  }

  .shopify-packages {
    input[type="checkbox"] {
      width: 0;
      height: 0;
      margin-right: 0;
      display: none;
    }
    .product--message {
      color: rgba(0, 0, 0, 0.87);
      font-size: 12px;
      display: block;
      margin-top: 10px;
      margin-bottom: 10px;
    }

    .product--compare,
    .go--to--pricing {
      color: ${(props) => props.theme.colors.primary.main}
      text-decoration: none;
      cursor: pointer;
      float: left;
      text-transform: none;
      font-weight: 400;
      margin-bottom: 10px;
      &:hover {
        color: ${(props) => props.theme.colors.primary.main}
        text-decoration: underline;
      }
    }
    .go--to--pricing {
      margin: 30px 0;
    }
    .shopify-item:first-child {
      margin-top: 30px !important;
    }
    .shopify-item {
      padding: 0;
      width: 97%;
      margin: auto;
      clear: both;
      ${media.desktop`
        padding: 0 0 10px;
      `}
      &.disabled {
        h3 {
          color: #4a4a4a;
          &.collapsed {
            color: #4a4a4a;
          }
        }
      }
      h3 {
        color: #4a4a4a;
        font-size: 16px;
        padding-top: 10px;
        cursor: pointer;
        font-weight: 400;
        margin-bottom: 0;
        @media only screen and (max-width: 1330px) {
          font-size: 16px;
        }
        @media only screen and (max-width: 1215px) {
          text-transform: none;
          font-size: 14px;
        }
        ${media.desktop`
          font-size: 16px;
        `}
        input[type="radio"] {
          display: none;
        }
      }
      h3.collapsed {
        color: #4a4a4a;
        padding-top: 0px;
      }
      p {
        color: #4a4a4a;
        padding-left: 29px;
      }
    }
    .advertisement {
      .inquire {
        float: right;
        color: #e0331a;
        text-decoration: underline;
        &:hover {
          color: #e0331a;
          text-decoration: none;
        }
      }
    }

    .product__label {
      margin-bottom: unset;
      .MuiTypography-root {
        width: 100%;
      }
      .Mui-checked svg {
        color: rgb(0, 163, 184);
      }
      .label--value {
        display: flex;
        color: rgba(0, 0, 0, 0.87);
        span:first-child {
          flex: 1 1 auto;
        }
      }
      .discount--text {
        color: rgba(0, 0, 0, 0.6);
        font-size: 12px;
        line-height: 16px;
        letter-spacing: 0.38px;
        margin-top: -15px;
        margin-bottom: unset;
        margin-left: 3px;
      }
    }
  }

  .RMuser {
    .item:hover {
      cursor: not-allowed !important;
      pointer-events: none;
      background: gray !important;
    }
    .item.active {
      background: gray !important;
    }
    .shopify-item h3 label {
      cursor: not-allowed !important;
      span {
        border-color: gray !important;
        cursor: not-allowed !important;
      }
    }
    .addToCart button {
      cursor: not-allowed !important;
      background: #e4e4e4;
    }
  }

  p.shopify-error {
    text-align: center;
    color: ${(props) => props.theme.colors.primary.main}
  }

  @media only screen and (max-device-width: 667px) and (min-device-width: 320px) and (orientation: portrait) {
    .addToCart {
      text-align: center;
    }
  }

  @media screen and (max-width: 991px) {
    margin-top: 0;
    .shopify-packages {
      .product__label {
        .label--value {
          font-size: 14px;
        }
        .discount--text {
          font-size: 11px;
        }
      }
    }
  }
`;
